let timeout = {}

export const debounce = (cb, time = 300, type = 'general', action = false) => {
  clearTimeout(timeout[type])
  if (action != 'cancel')
  timeout[type] = setTimeout(() => {
    delete timeout[type]
    cb()
  }, time)
}
